var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStore } from "@context/store";
import { useUI } from "@context/ui";
import { Formik } from "formik";
import { FormStateProvider, useFormState } from "./context";
import ZipCodeField from "./ZipCodeField";
import { Button } from "@components/ui";
import { ZIP_CODE_SCHEMA } from "@schema/index";
import FallbackModal from "../FallbackModal";
import s from "./ZipCodeForm.module.css";
import { useState } from "preact/hooks";
import classNames from "classnames";
export var initialValues = {
    zip: "",
};
export var ConfirmButton = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var rootClassNames = classNames(s.button, className);
    return (_jsx(Button, __assign({ className: rootClassNames, type: "submit", primary: true }, props, { children: "Confirm" }), void 0));
};
var ZipCodeForm = function () {
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var locations = useFormState().locations;
    var setLocation = useStore().setLocation;
    var nextStep = useUI().nextStep;
    var onSubmit = function () {
        if (locations) {
            setLocation(__assign({}, locations[0]));
            nextStep();
        }
    };
    var buttonClasses = "float-left mr-2 mb-2";
    var openModal = function () {
        setShowModal(true);
    };
    var closeModal = function () {
        setShowModal(false);
    };
    return (_jsxs("div", __assign({ className: "overflow-hidden" }, { children: [_jsx(Formik, __assign({ initialValues: initialValues, validationSchema: ZIP_CODE_SCHEMA, onSubmit: onSubmit }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, isValid = _a.isValid, dirty = _a.dirty;
                    return (_jsx("form", __assign({ onSubmit: handleSubmit, autoComplete: "off" }, { children: _jsxs("div", __assign({ className: "pr-10 space-y-2" }, { children: [_jsx(ZipCodeField, { className: "max-w-xs" }, void 0),
                                _jsx(ConfirmButton, { className: buttonClasses, disabled: !(isValid && dirty) }, void 0),
                                !isValid && (_jsx(Button, __assign({ className: buttonClasses, onClick: openModal }, { children: "Inform me when available" }), void 0))] }), void 0) }), void 0));
                } }), void 0),
            _jsx("div", { className: "clear-both" }, void 0),
            _jsx(FallbackModal, { open: showModal, onClose: closeModal }, void 0)] }), void 0));
};
var AddressFormWithContext = function (props) {
    return (_jsx(FormStateProvider, { children: _jsx(ZipCodeForm, __assign({}, props), void 0) }, void 0));
};
export default AddressFormWithContext;
